/**
 * Mobile ✦ Ask FAB — pinned above the bottom tab bar on every screen.
 * Opens the Ask the Cook bottom sheet (handled in App.jsx).
 * When locked, the control stays visible and explains account creation on tap.
 */
export default function AskTheCookFab({ onClick, hidden = false, locked = false }) {
  if (hidden) return null

  return (
    <button
      type="button"
      className={`ask-the-cook-fab${locked ? ' is-locked' : ''}`}
      onClick={onClick}
      aria-label={
        locked
          ? 'Ask the Cook. Create an account to get help from the Captain.'
          : 'Ask the Cook'
      }
      aria-disabled={locked || undefined}
      data-testid="ask-the-cook-fab"
    >
      {locked ? <i className="fas fa-lock ask-the-cook-fab-lock" aria-hidden="true" /> : null}
      <span className="ask-the-cook-fab-sparkle" aria-hidden="true">✦</span>
      Ask
    </button>
  )
}
